/**
 * FikoDFM Module - DFM Analysis Panel
 */

export { FikoDFMComponent } from './fiko-dfm.component';
export type { DFMViewMode, DFMAyarlar } from './fiko-dfm.component';
